import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Header, Results, AddUser } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const BackofficeUsers = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [isadd, setIsadd] = useState(false);
  const [userobj, setUserobj] = useState({});
  const [viewtype, setViewtype] = useState(1);
  const snackbarCtx = React.useContext(SnackBarContext);
  const [roles, setRoles] = useState([]);

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  function addadminuser()
  {
    setViewtype(1)
    setUserobj(null)
    setIsadd(true)
  }

  function editadminuser(userobj)
  {
    let role_arr = []
    let userroles = []
    if(userobj.roles)
    {    
      userobj.roles.forEach(element => {
      role_arr.push(element.role_id)
    });
    roles.forEach(element => {
      if(role_arr.includes(element.id))
      {
        userroles.push(element)
      }
    });

    userobj['user_roles'] = userroles
  }
    setViewtype(2)
    setUserobj(userobj)
    setIsadd(true)
  }
  function resetpassword(userobj)
  {
    setViewtype(3)
    setUserobj(userobj)
    setIsadd(true)
  }
  async function fetchrolemaster()
  {
    let role_arr = await sendNetworkRequest('/admin/getactiveroles', {}, {},false)
    if(role_arr) 
    {
      setRoles(role_arr)
    }
  }
  async function updateuserstatus(userobj, status)
  {

    
    let bodycontent = {}
    bodycontent['status'] = status;

    if(userobj)
    {
      bodycontent['id'] = userobj.id;
      bodycontent['username'] = userobj.username;

     
    }
    let masterroles_arr = await sendNetworkRequest('/auth/updateemployeestatus', {}, bodycontent,false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: "success"  ,
      msg: "Updated Successfully",
      vertical: "top",
    });
    setIsadd(false)
    fetchadminusers()
  }
  
  
 async function updateuser(userobj)
  {
   
   
    let bodycontent = {}
    if(userobj.id)
    {
      if(viewtype == 3)
      {
        bodycontent['password'] = userobj.password;
        bodycontent['id'] = userobj.id;
       let masterroles_arr = await sendNetworkRequest('/auth/changepassword', {}, bodycontent,false)
      snackbarCtx.setSnack({
        ...snackbarCtx,
        open: true,
        type: masterroles_arr.status,
        msg: masterroles_arr.message,
        vertical: "top",
      }); 
    }else{
      bodycontent['name'] = userobj.name; 
      bodycontent['mobile'] = userobj.mobile; 
      bodycontent['roles'] = userobj.user_roles; 
      bodycontent['username'] = userobj.username; 
        bodycontent['id'] = userobj.id;
       bodycontent['status']  = userobj.status 
      let masterroles_arr = await sendNetworkRequest('/auth/employeeupdate', {}, bodycontent,false)
      snackbarCtx.setSnack({
        ...snackbarCtx,
        open: true,
        type: masterroles_arr.status,
        msg: masterroles_arr.message,
        vertical: "top",
      });
    }
      
      
    }else{
      bodycontent = {
        ...userobj
      }
      bodycontent['roles'] = userobj.user_roles; 
      bodycontent['status'] = true;
      let userprofile_arr = await sendNetworkRequest('/auth/employeeregistration', {}, bodycontent,false)
      // snackbarCtx.setSnack({
      //   ...snackbarCtx,
      //   open: true,
      //   type: userprofile_arr.status,
      //   msg: userprofile_arr.message,
      //   vertical: "top",
      // });

    
     }

    //  snackbarCtx.setSnack({
    //   ...snackbarCtx,
    //   open: true,
    //   type: viewtype == 1 ? "success" : viewtype == 2 ? "success" : "error" ,
    //   msg: viewtype == 1 ? "Created Successfully" : viewtype == 2 ? "Updated Successfully" : "Please try after sometime",
    //   vertical: "top",
    // });
     setIsadd(false)
    fetchadminusers()

  }

  function dismiss()
  {
    setIsadd(false)
  }
  useEffect(() => {
    fetchrolemaster()
    fetchadminusers()
    
  }, []);

  async function fetchadminusers()
  {
    let adminusers = await sendNetworkRequest('/admin/getemployees', {}, {},false)
    setOrders(adminusers)
  }
  return (
    <Page
      className={classes.root}
      title="Employee"
    >
      <Header onAdd={addadminuser} />
      {isadd ? <AddUser viewtype={viewtype} masterroles={roles} onUpdate={updateuser} onDismiss={dismiss} userobj={userobj}/> : null}
       {/* <UserFilter />  */}
      <Results
        onEdit={editadminuser}
        onReset={resetpassword}
        onUpdatestatus={updateuserstatus}
        className={classes.results}
        orders={orders} //
      />
     
    </Page>
  );
});

export default BackofficeUsers;
